// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FormSelect-module__font-s-10___pp9Qe {
  font-size: 10px !important;
}

.FormSelect-module__font-s-12___QXkxJ {
  font-size: 12px !important;
}

.FormSelect-module__font-s-13___Ev6uI {
  font-size: 13px !important;
}

.FormSelect-module__font-s-14___eXjuX {
  font-size: 14px !important;
}

.FormSelect-module__font-s-15___h9ZMI {
  font-size: 15px !important;
}

.FormSelect-module__font-s-16___sPwbN {
  font-size: 16px !important;
}

.FormSelect-module__font-s-18___SUrqK {
  font-size: 18px !important;
}

.FormSelect-module__font-s-20___NGLac {
  font-size: 20px !important;
}

.FormSelect-module__font-s-22___zgg5Z {
  font-size: 22px !important;
}

.FormSelect-module__font-s-28___DX6ZN {
  font-size: 28px !important;
}

.FormSelect-module__font-w-400___alfO8 {
  font-weight: 400 !important;
}

.FormSelect-module__font-w-500___AlM1d {
  font-weight: 500 !important;
}

.FormSelect-module__font-w-600___YjJzt {
  font-weight: 600 !important;
}

.FormSelect-module__font-w-700___fllSl {
  font-weight: 700 !important;
}

.FormSelect-module__p-5___s9mX4 {
  padding: 5px !important;
}

.FormSelect-module__p-12___lcYPV {
  padding: 12px !important;
}

.FormSelect-module__p-16___zjS_a {
  padding: 16px !important;
}

.FormSelect-module__p-30___PRfvM {
  padding: 30px !important;
}

.FormSelect-module__p-b-0___o_j0x {
  padding-bottom: 0 !important;
}

.FormSelect-module__p-b-5___GzLTn {
  padding-bottom: 5px !important;
}

.FormSelect-module__p-b-10___l33G4 {
  padding-bottom: 10px !important;
}

.FormSelect-module__p-b-12___WTucC {
  padding-bottom: 12px !important;
}

.FormSelect-module__p-b-16___NH4Fh {
  padding-bottom: 16px !important;
}

.FormSelect-module__p-b-18___vu5um {
  padding-bottom: 18px !important;
}

.FormSelect-module__p-b-20___KmwZ8 {
  padding-bottom: 20px !important;
}

.FormSelect-module__p-b-25___lNPhn {
  padding-bottom: 25px !important;
}

.FormSelect-module__p-b-30___gTrJD {
  padding-bottom: 30px !important;
}

.FormSelect-module__p-b-50___hOlNf {
  padding-bottom: 50px !important;
}

.FormSelect-module__p-t-0___kJ96O {
  padding-top: 0 !important;
}

.FormSelect-module__p-t-12___U20mZ {
  padding-top: 12px !important;
}

.FormSelect-module__p-t-16___lmkx4 {
  padding-top: 16px !important;
}

.FormSelect-module__p-t-18___JeA_g {
  padding-top: 18px !important;
}

.FormSelect-module__p-t-20___mZaE3 {
  padding-top: 20px !important;
}

.FormSelect-module__p-t-30___DwV0W {
  padding-top: 30px !important;
}

.FormSelect-module__p-t-40___OIRMR {
  padding-top: 40px !important;
}

.FormSelect-module__p-t-50___NL0Iu {
  padding-top: 50px !important;
}

.FormSelect-module__p-l-20___FSn96 {
  padding-left: 20px !important;
}

.FormSelect-module__p-l-30___DW3L9 {
  padding-left: 30px !important;
}

.FormSelect-module__p-l-40___rnjJX {
  padding-left: 40px !important;
}

.FormSelect-module__p-r-16___SpLGH {
  padding-right: 16px !important;
}

.FormSelect-module__p-r-20___yJDvp {
  padding-right: 20px !important;
}

.FormSelect-module__p-r-30___khOiv {
  padding-right: 30px !important;
}

.FormSelect-module__p-r-50___bKsbi {
  padding-right: 50px !important;
}

.FormSelect-module__p-r-60___ENRtG {
  padding-right: 60px !important;
}

.FormSelect-module__m-b-1____vIC1 {
  margin-bottom: 1px !important;
}

.FormSelect-module__m-b-2___bpnyY {
  margin-bottom: 2px !important;
}

.FormSelect-module__m-b-6____oWuh {
  margin-bottom: 6px !important;
}

.FormSelect-module__m-b-8___t5Y6B {
  margin-bottom: 8px !important;
}

.FormSelect-module__m-b-10___d3WKb {
  margin-bottom: 10px !important;
}

.FormSelect-module__m-b-14___D2kQF {
  margin-bottom: 14px !important;
}

.FormSelect-module__m-b-16___n52Gt {
  margin-bottom: 16px !important;
}

.FormSelect-module__m-b-20___Gc5jH {
  margin-bottom: 20px !important;
}

.FormSelect-module__m-b-22___kJttn {
  margin-bottom: 22px !important;
}

.FormSelect-module__m-b-24___nSl1y {
  margin-bottom: 24px !important;
}

.FormSelect-module__m-b-30___OtdoT {
  margin-bottom: 30px !important;
}

.FormSelect-module__m-b-32___c46Mh {
  margin-bottom: 32px !important;
}

.FormSelect-module__m-b-40___oc2MH {
  margin-bottom: 40px !important;
}

.FormSelect-module__m-t-2___PVkIw {
  margin-top: 2px !important;
}

.FormSelect-module__m-t-3___Oa3Y3 {
  margin-top: 3px !important;
}

.FormSelect-module__m-t-4___V2yza {
  margin-top: 4px !important;
}

.FormSelect-module__m-t-5___Ixkv5 {
  margin-top: 5px !important;
}

.FormSelect-module__m-t-8___i1zg_ {
  margin-top: 8px !important;
}

.FormSelect-module__m-t-10___LNvN6 {
  margin-top: 10px !important;
}

.FormSelect-module__m-t-15___Wwn2j {
  margin-top: 15px !important;
}

.FormSelect-module__m-t-16___JAP11 {
  margin-top: 16px !important;
}

.FormSelect-module__m-t-20___Qg289 {
  margin-top: 20px !important;
}

.FormSelect-module__m-t-22___wAQUo {
  margin-top: 22px !important;
}

.FormSelect-module__m-t-30___XSGZq {
  margin-top: 30px !important;
}

.FormSelect-module__m-t-32___gYL8K {
  margin-top: 32px !important;
}

.FormSelect-module__m-l-auto___plQ1Z {
  margin-left: auto !important;
}

.FormSelect-module__m-l-4___HQSKj {
  margin-left: 4px !important;
}

.FormSelect-module__m-l-5___CVLnX {
  margin-left: 5px !important;
}

.FormSelect-module__m-l-6___ZAMmW {
  margin-left: 6px !important;
}

.FormSelect-module__m-l-8___hsQB9 {
  margin-left: 8px !important;
}

.FormSelect-module__m-l-10___E_yix {
  margin-left: 10px !important;
}

.FormSelect-module__m-l-16___A8pAj {
  margin-left: 16px !important;
}

.FormSelect-module__m-l-20___Xl_Ta {
  margin-left: 20px !important;
}

.FormSelect-module__m-l-24___Vn8TO {
  margin-left: 24px !important;
}

.FormSelect-module__m-l-30___cZHFr {
  margin-left: 30px !important;
}

.FormSelect-module__m-l-35___yaKQN {
  margin-left: 35px !important;
}

.FormSelect-module__m-l-40___v3VQZ {
  margin-left: 40px !important;
}

.FormSelect-module__m-r-8___foUCr {
  margin-right: 8px !important;
}

.FormSelect-module__m-r-10___nHVdq {
  margin-right: 10px !important;
}

.FormSelect-module__m-r-16___MMLMW {
  margin-right: 16px !important;
}

.FormSelect-module__m-r-20___uCPKe {
  margin-right: 20px !important;
}

.FormSelect-module__m-r-24___ZkE2I {
  margin-right: 24px !important;
}

.FormSelect-module__m-r-30___tpN2N {
  margin-right: 30px !important;
}

.FormSelect-module__m-r-40___tF25Q {
  margin-right: 40px !important;
}

.FormSelect-module__border-r-3___frlZf {
  border-radius: 3px !important;
}

.FormSelect-module__border-r-4___Dl458 {
  border-radius: 4px !important;
}

.FormSelect-module__border-r-6___FBthK {
  border-radius: 6px !important;
}

.FormSelect-module__border-r-10___IgELG {
  border-radius: 10px !important;
}

.FormSelect-module__border-r-12___ypUoj {
  border-radius: 12px !important;
}

.FormSelect-module__border-r-16___P3Cht {
  border-radius: 16px !important;
}

.FormSelect-module__border-r-50___kTZ94 {
  border-radius: 50% !important;
}

.FormSelect-module__primary-border___DkQsv {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.FormSelect-module__primary-border-b___A6yuh {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.FormSelect-module__primary-border-t___qI4dv {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.FormSelect-module__primary-border-l___Bnhnm {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.FormSelect-module__primary-border-r___YvCeg {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.FormSelect-module__secondary-border___lmt1s {
  border: 1px solid #637768;
}

.FormSelect-module__secondary-border-b___XVQ4Q {
  border-bottom: 1px solid #637768;
}

.FormSelect-module__secondary-border-t___E5brL {
  border-top: 1px solid #637768;
}

.FormSelect-module__secondary-border-l___S0KLR {
  border-left: 1px solid #637768;
}

.FormSelect-module__secondary-border-r___U6uEM {
  border-right: 1px solid #637768;
}

.FormSelect-module__gap-0___Y1vUS {
  gap: 0 !important;
}

.FormSelect-module__gap-2___GyrIa {
  gap: 2px !important;
}

.FormSelect-module__gap-4____oHA4 {
  gap: 4px !important;
}

.FormSelect-module__gap-5___bhGcz {
  gap: 5px !important;
}

.FormSelect-module__gap-6___nyP8S {
  gap: 6px !important;
}

.FormSelect-module__gap-8___LCPgN {
  gap: 8px !important;
}

.FormSelect-module__gap-10___zv7z2 {
  gap: 10px !important;
}

.FormSelect-module__gap-12___Tt_xR {
  gap: 12px !important;
}

.FormSelect-module__gap-14___DoBMA {
  gap: 14px !important;
}

.FormSelect-module__gap-16___jbTUX {
  gap: 16px !important;
}

.FormSelect-module__gap-18___tt9V6 {
  gap: 18px !important;
}

.FormSelect-module__gap-20___Vn9fM {
  gap: 20px !important;
}

.FormSelect-module__gap-24___hX1QN {
  gap: 24px !important;
}

.FormSelect-module__gap-26___OxPwv {
  gap: 26px !important;
}

.FormSelect-module__gap-30___G5pQI {
  gap: 30px !important;
}

.FormSelect-module__gap-32___RqKL7 {
  gap: 32px !important;
}

.FormSelect-module__gap-40___fjuoG {
  gap: 40px !important;
}

.FormSelect-module__gap-50___V9l6B {
  gap: 50px !important;
}

.FormSelect-module__flex-1___jHj_A {
  flex: 1;
}

.FormSelect-module__flex-none___w6ZRz {
  flex: none !important;
}

.FormSelect-module__flex-column___KXC1V {
  display: flex;
  flex-direction: column !important;
}

.FormSelect-module__flex-row___Ys2Ra {
  display: flex;
  flex-direction: row !important;
}

.FormSelect-module__vertically-centered___QLWGN {
  display: flex;
  align-items: center !important;
}

.FormSelect-module__horizontally-centered___APA9_ {
  display: flex;
  justify-content: center !important;
}

.FormSelect-module__horizontally-end___QaQZw {
  display: flex;
  justify-content: end !important;
}

.FormSelect-module__vertically-start___luY1s {
  display: flex;
  align-items: start !important;
}

.FormSelect-module__space-between___ATsat {
  display: flex;
  justify-content: space-between !important;
}

.FormSelect-module__flex-wrap___u38a3 {
  flex-wrap: wrap !important;
}

.FormSelect-module__height-100___u3zIB {
  height: 100%;
}

.FormSelect-module__width-50___y7DZd {
  width: 50% !important;
}

.FormSelect-module__width-100___Hc0S6 {
  width: 100%;
}

.FormSelect-module__cursor-pointer___DAt3W {
  cursor: pointer;
}

.FormSelect-module__cursor-not-allowed___f_t09 {
  cursor: not-allowed !important;
}

.FormSelect-module__absolute-centered___MNgy_ {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.FormSelect-module__absolute___saqUg {
  position: absolute;
}

.FormSelect-module__relative___yfKtc {
  position: relative;
}

.FormSelect-module__fixed___I6wyx {
  position: fixed;
}

.FormSelect-module__visible___GXdyP {
  opacity: 1;
}

.FormSelect-module__invisible___lFGyv {
  opacity: 0;
}

.FormSelect-module__col-90___jDrOS {
  width: 90% !important;
}

.FormSelect-module__col-auto___acix2 {
  width: auto !important;
}

.FormSelect-module__medical-tabs___SMfJF {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.FormSelect-module__medical-table-new___tCYbF {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.FormSelect-module__medical-table-new___tCYbF:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.FormSelect-module__medical-table-new___tCYbF::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.FormSelect-module__medical-table-new___tCYbF::-webkit-scrollbar-track {
  display: none;
}
.FormSelect-module__medical-table-new___tCYbF.FormSelect-module__no-pagination___sV10m {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.FormSelect-module__medical-table-new___tCYbF.FormSelect-module__no-pagination___sV10m:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.FormSelect-module__medical-table-new___tCYbF.FormSelect-module__no-pagination___sV10m::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.FormSelect-module__medical-table-new___tCYbF.FormSelect-module__no-pagination___sV10m::-webkit-scrollbar-track {
  display: none;
}

.FormSelect-module__medical-table-empty___pnNrF {
  padding: 14px 40px !important;
}

.FormSelect-module__icon-btn___bzX0Y {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.FormSelect-module__search-icon___oKnBV {
  width: 24px;
  height: 24px;
  align-self: center;
}

.FormSelect-module__disable-select___I26_d {
  user-select: none;
}

.FormSelect-module__break-word___qirLb {
  word-break: break-word;
}

.FormSelect-module__popup-clear-btn___xiYdP {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.FormSelect-module__scroll-m-b-20___YWp2w {
  scroll-margin-bottom: 20px;
}

.FormSelect-module__container___Hwrvj {
  color: #375844;
}
.FormSelect-module__container___Hwrvj .FormSelect-module__select___vIyyK {
  cursor: pointer;
  padding: 6.5px 8px;
}
.FormSelect-module__container___Hwrvj .FormSelect-module__select___vIyyK.FormSelect-module__disabled___mN9V6 {
  cursor: not-allowed;
  opacity: 0.6;
}
.FormSelect-module__container___Hwrvj .FormSelect-module__select___vIyyK.FormSelect-module__withError___XcTYY {
  color: #db2828;
  border-color: #db2828;
  background-color: rgba(219, 40, 40, 0.1);
}
.FormSelect-module__container___Hwrvj .FormSelect-module__select___vIyyK .FormSelect-module__icon___dKLwU {
  width: 16px;
  height: 16px;
}
.FormSelect-module__container___Hwrvj .FormSelect-module__select___vIyyK .FormSelect-module__placeholder___Zwvee {
  color: #bcbec0;
}
.FormSelect-module__container___Hwrvj .FormSelect-module__select___vIyyK .FormSelect-module__placeholder___Zwvee.FormSelect-module__withError___XcTYY {
  color: #db2828;
}
.FormSelect-module__container___Hwrvj .FormSelect-module__select___vIyyK .FormSelect-module__multipleValue___SvHwf {
  flex-wrap: wrap;
}
.FormSelect-module__container___Hwrvj .FormSelect-module__select___vIyyK .FormSelect-module__multipleValue___SvHwf .FormSelect-module__item___Ptizs {
  background-color: #e6e7e8;
  color: #375844;
  width: fit-content;
  padding: 5px;
  box-sizing: border-box;
}
.FormSelect-module__container___Hwrvj .FormSelect-module__select___vIyyK .FormSelect-module__multipleValue___SvHwf .FormSelect-module__closeIcon___vX1Oc {
  width: 18px;
  height: 18px;
  pointer-events: auto;
}
.FormSelect-module__container___Hwrvj .FormSelect-module__select___vIyyK .FormSelect-module__value___EUHkn {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #375844;
}
.FormSelect-module__container___Hwrvj .FormSelect-module__select___vIyyK .FormSelect-module__inputWrapper___csVBU {
  min-width: 50px;
  align-self: center;
}
.FormSelect-module__container___Hwrvj .FormSelect-module__select___vIyyK .FormSelect-module__input___dQped {
  border: none !important;
}
.FormSelect-module__container___Hwrvj .FormSelect-module__select___vIyyK .FormSelect-module__input___dQped > input {
  padding: 0 0 0 5px;
  pointer-events: auto;
}
.FormSelect-module__container___Hwrvj .FormSelect-module__select___vIyyK .FormSelect-module__iconsWrapper___GXZXr {
  margin-left: auto;
}
.FormSelect-module__container___Hwrvj .FormSelect-module__error___FN68z {
  color: #c56836;
  min-height: 15px;
  display: block;
}
.FormSelect-module__container___Hwrvj .FormSelect-module__paper___L43bK {
  box-shadow: 0 0 4px 0 #6d7278;
  background-color: white;
  box-sizing: border-box;
  pointer-events: auto;
  overflow-y: scroll;
  border-radius: 5px;
  max-height: 40vh;
  position: fixed;
  padding: 10px;
  z-index: 100;
}
.FormSelect-module__container___Hwrvj .FormSelect-module__paper___L43bK .FormSelect-module__emptyPlaceholder___FIsqr {
  color: #375844;
}
.FormSelect-module__container___Hwrvj .FormSelect-module__withError___XcTYY {
  color: #db2828;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./../common/src/components/base/FormSelect/FormSelect.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;AA8pBF;AA5pBE;EACE,eAAA;EACA,kBAAA;AA8pBJ;AA5pBI;EACE,mBAAA;EACA,YAAA;AA8pBN;AA3pBI;EACE,cAAA;EACA,qBAAA;EACA,wCAAA;AA6pBN;AA1pBI;EACE,WAAA;EACA,YAAA;AA4pBN;AAzpBI;EACE,cAAA;AA2pBN;AAzpBM;EACE,cAAA;AA2pBR;AAvpBI;EACE,eAAA;AAypBN;AAvpBM;EACE,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;AAypBR;AAtpBM;EACE,WAAA;EACA,YAAA;EACA,oBAAA;AAwpBR;AAppBI;EC/CF,gBAAA;EACA,mBAAA;EACA,uBAAA;ED+CI,cAAA;AAwpBN;AArpBI;EACE,eAAA;EACA,kBAAA;AAupBN;AAppBI;EACE,uBAAA;AAspBN;AAppBM;EACE,kBAAA;EACA,oBAAA;AAspBR;AAlpBI;EACE,iBAAA;AAopBN;AAhpBE;EACE,cAAA;EACA,gBAAA;EACA,cAAA;AAkpBJ;AA/oBE;EACE,6BAAA;EACA,uBAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;AAipBJ;AA/oBI;EACE,cAAA;AAipBN;AA7oBE;EACE,cAAA;AA+oBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  color: get-color(greenNew, dark);\n\n  .select {\n    cursor: pointer;\n    padding: 6.5px 8px;\n\n    &.disabled {\n      cursor: not-allowed;\n      opacity: 0.6;\n    }\n\n    &.withError {\n      color: get-color(redNew, medium);\n      border-color: get-color(redNew, medium);\n      background-color: get-color(redNew, light);\n    }\n\n    .icon {\n      width: 16px;\n      height: 16px;\n    }\n\n    .placeholder {\n      color: get-color(gray, medium);\n\n      &.withError {\n        color: get-color(redNew, medium);\n      }\n    }\n\n    .multipleValue {\n      flex-wrap: wrap;\n\n      .item {\n        background-color: get-color(gray, light);\n        color: get-color(greenNew, dark);\n        width: fit-content;\n        padding: 5px;\n        box-sizing: border-box;\n      }\n\n      .closeIcon {\n        width: 18px;\n        height: 18px;\n        pointer-events: auto;\n      }\n    }\n\n    .value {\n      @include clipped-text;\n      color: get-color(greenNew, dark);\n    }\n\n    .inputWrapper {\n      min-width: 50px;\n      align-self: center;\n    }\n\n    .input {\n      border: none !important;\n\n      & > input {\n        padding: 0 0 0 5px;\n        pointer-events: auto;\n      }\n    }\n\n    .iconsWrapper {\n      margin-left: auto;\n    }\n  }\n\n  .error {\n    color: get-color(orangeNew, dark);\n    min-height: 15px;\n    display: block;\n  }\n\n  .paper {\n    box-shadow: 0 0 4px 0 get-color(gray, dark);\n    background-color: get-color(white);\n    box-sizing: border-box;\n    pointer-events: auto;\n    overflow-y: scroll;\n    border-radius: 5px;\n    max-height: 40vh;\n    position: fixed;\n    padding: 10px;\n    z-index: 100;\n\n    .emptyPlaceholder {\n      color: get-color(greenNew, dark);\n    }\n  }\n\n  .withError {\n    color: get-color(redNew, medium);\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `FormSelect-module__font-s-10___pp9Qe`,
	"fontS12": `FormSelect-module__font-s-12___QXkxJ`,
	"fontS13": `FormSelect-module__font-s-13___Ev6uI`,
	"fontS14": `FormSelect-module__font-s-14___eXjuX`,
	"fontS15": `FormSelect-module__font-s-15___h9ZMI`,
	"fontS16": `FormSelect-module__font-s-16___sPwbN`,
	"fontS18": `FormSelect-module__font-s-18___SUrqK`,
	"fontS20": `FormSelect-module__font-s-20___NGLac`,
	"fontS22": `FormSelect-module__font-s-22___zgg5Z`,
	"fontS28": `FormSelect-module__font-s-28___DX6ZN`,
	"fontW400": `FormSelect-module__font-w-400___alfO8`,
	"fontW500": `FormSelect-module__font-w-500___AlM1d`,
	"fontW600": `FormSelect-module__font-w-600___YjJzt`,
	"fontW700": `FormSelect-module__font-w-700___fllSl`,
	"p5": `FormSelect-module__p-5___s9mX4`,
	"p12": `FormSelect-module__p-12___lcYPV`,
	"p16": `FormSelect-module__p-16___zjS_a`,
	"p30": `FormSelect-module__p-30___PRfvM`,
	"pB0": `FormSelect-module__p-b-0___o_j0x`,
	"pB5": `FormSelect-module__p-b-5___GzLTn`,
	"pB10": `FormSelect-module__p-b-10___l33G4`,
	"pB12": `FormSelect-module__p-b-12___WTucC`,
	"pB16": `FormSelect-module__p-b-16___NH4Fh`,
	"pB18": `FormSelect-module__p-b-18___vu5um`,
	"pB20": `FormSelect-module__p-b-20___KmwZ8`,
	"pB25": `FormSelect-module__p-b-25___lNPhn`,
	"pB30": `FormSelect-module__p-b-30___gTrJD`,
	"pB50": `FormSelect-module__p-b-50___hOlNf`,
	"pT0": `FormSelect-module__p-t-0___kJ96O`,
	"pT12": `FormSelect-module__p-t-12___U20mZ`,
	"pT16": `FormSelect-module__p-t-16___lmkx4`,
	"pT18": `FormSelect-module__p-t-18___JeA_g`,
	"pT20": `FormSelect-module__p-t-20___mZaE3`,
	"pT30": `FormSelect-module__p-t-30___DwV0W`,
	"pT40": `FormSelect-module__p-t-40___OIRMR`,
	"pT50": `FormSelect-module__p-t-50___NL0Iu`,
	"pL20": `FormSelect-module__p-l-20___FSn96`,
	"pL30": `FormSelect-module__p-l-30___DW3L9`,
	"pL40": `FormSelect-module__p-l-40___rnjJX`,
	"pR16": `FormSelect-module__p-r-16___SpLGH`,
	"pR20": `FormSelect-module__p-r-20___yJDvp`,
	"pR30": `FormSelect-module__p-r-30___khOiv`,
	"pR50": `FormSelect-module__p-r-50___bKsbi`,
	"pR60": `FormSelect-module__p-r-60___ENRtG`,
	"mB1": `FormSelect-module__m-b-1____vIC1`,
	"mB2": `FormSelect-module__m-b-2___bpnyY`,
	"mB6": `FormSelect-module__m-b-6____oWuh`,
	"mB8": `FormSelect-module__m-b-8___t5Y6B`,
	"mB10": `FormSelect-module__m-b-10___d3WKb`,
	"mB14": `FormSelect-module__m-b-14___D2kQF`,
	"mB16": `FormSelect-module__m-b-16___n52Gt`,
	"mB20": `FormSelect-module__m-b-20___Gc5jH`,
	"mB22": `FormSelect-module__m-b-22___kJttn`,
	"mB24": `FormSelect-module__m-b-24___nSl1y`,
	"mB30": `FormSelect-module__m-b-30___OtdoT`,
	"mB32": `FormSelect-module__m-b-32___c46Mh`,
	"mB40": `FormSelect-module__m-b-40___oc2MH`,
	"mT2": `FormSelect-module__m-t-2___PVkIw`,
	"mT3": `FormSelect-module__m-t-3___Oa3Y3`,
	"mT4": `FormSelect-module__m-t-4___V2yza`,
	"mT5": `FormSelect-module__m-t-5___Ixkv5`,
	"mT8": `FormSelect-module__m-t-8___i1zg_`,
	"mT10": `FormSelect-module__m-t-10___LNvN6`,
	"mT15": `FormSelect-module__m-t-15___Wwn2j`,
	"mT16": `FormSelect-module__m-t-16___JAP11`,
	"mT20": `FormSelect-module__m-t-20___Qg289`,
	"mT22": `FormSelect-module__m-t-22___wAQUo`,
	"mT30": `FormSelect-module__m-t-30___XSGZq`,
	"mT32": `FormSelect-module__m-t-32___gYL8K`,
	"mLAuto": `FormSelect-module__m-l-auto___plQ1Z`,
	"mL4": `FormSelect-module__m-l-4___HQSKj`,
	"mL5": `FormSelect-module__m-l-5___CVLnX`,
	"mL6": `FormSelect-module__m-l-6___ZAMmW`,
	"mL8": `FormSelect-module__m-l-8___hsQB9`,
	"mL10": `FormSelect-module__m-l-10___E_yix`,
	"mL16": `FormSelect-module__m-l-16___A8pAj`,
	"mL20": `FormSelect-module__m-l-20___Xl_Ta`,
	"mL24": `FormSelect-module__m-l-24___Vn8TO`,
	"mL30": `FormSelect-module__m-l-30___cZHFr`,
	"mL35": `FormSelect-module__m-l-35___yaKQN`,
	"mL40": `FormSelect-module__m-l-40___v3VQZ`,
	"mR8": `FormSelect-module__m-r-8___foUCr`,
	"mR10": `FormSelect-module__m-r-10___nHVdq`,
	"mR16": `FormSelect-module__m-r-16___MMLMW`,
	"mR20": `FormSelect-module__m-r-20___uCPKe`,
	"mR24": `FormSelect-module__m-r-24___ZkE2I`,
	"mR30": `FormSelect-module__m-r-30___tpN2N`,
	"mR40": `FormSelect-module__m-r-40___tF25Q`,
	"borderR3": `FormSelect-module__border-r-3___frlZf`,
	"borderR4": `FormSelect-module__border-r-4___Dl458`,
	"borderR6": `FormSelect-module__border-r-6___FBthK`,
	"borderR10": `FormSelect-module__border-r-10___IgELG`,
	"borderR12": `FormSelect-module__border-r-12___ypUoj`,
	"borderR16": `FormSelect-module__border-r-16___P3Cht`,
	"borderR50": `FormSelect-module__border-r-50___kTZ94`,
	"primaryBorder": `FormSelect-module__primary-border___DkQsv`,
	"primaryBorderB": `FormSelect-module__primary-border-b___A6yuh`,
	"primaryBorderT": `FormSelect-module__primary-border-t___qI4dv`,
	"primaryBorderL": `FormSelect-module__primary-border-l___Bnhnm`,
	"primaryBorderR": `FormSelect-module__primary-border-r___YvCeg`,
	"secondaryBorder": `FormSelect-module__secondary-border___lmt1s`,
	"secondaryBorderB": `FormSelect-module__secondary-border-b___XVQ4Q`,
	"secondaryBorderT": `FormSelect-module__secondary-border-t___E5brL`,
	"secondaryBorderL": `FormSelect-module__secondary-border-l___S0KLR`,
	"secondaryBorderR": `FormSelect-module__secondary-border-r___U6uEM`,
	"gap0": `FormSelect-module__gap-0___Y1vUS`,
	"gap2": `FormSelect-module__gap-2___GyrIa`,
	"gap4": `FormSelect-module__gap-4____oHA4`,
	"gap5": `FormSelect-module__gap-5___bhGcz`,
	"gap6": `FormSelect-module__gap-6___nyP8S`,
	"gap8": `FormSelect-module__gap-8___LCPgN`,
	"gap10": `FormSelect-module__gap-10___zv7z2`,
	"gap12": `FormSelect-module__gap-12___Tt_xR`,
	"gap14": `FormSelect-module__gap-14___DoBMA`,
	"gap16": `FormSelect-module__gap-16___jbTUX`,
	"gap18": `FormSelect-module__gap-18___tt9V6`,
	"gap20": `FormSelect-module__gap-20___Vn9fM`,
	"gap24": `FormSelect-module__gap-24___hX1QN`,
	"gap26": `FormSelect-module__gap-26___OxPwv`,
	"gap30": `FormSelect-module__gap-30___G5pQI`,
	"gap32": `FormSelect-module__gap-32___RqKL7`,
	"gap40": `FormSelect-module__gap-40___fjuoG`,
	"gap50": `FormSelect-module__gap-50___V9l6B`,
	"flex1": `FormSelect-module__flex-1___jHj_A`,
	"flexNone": `FormSelect-module__flex-none___w6ZRz`,
	"flexColumn": `FormSelect-module__flex-column___KXC1V`,
	"flexRow": `FormSelect-module__flex-row___Ys2Ra`,
	"verticallyCentered": `FormSelect-module__vertically-centered___QLWGN`,
	"horizontallyCentered": `FormSelect-module__horizontally-centered___APA9_`,
	"horizontallyEnd": `FormSelect-module__horizontally-end___QaQZw`,
	"verticallyStart": `FormSelect-module__vertically-start___luY1s`,
	"spaceBetween": `FormSelect-module__space-between___ATsat`,
	"flexWrap": `FormSelect-module__flex-wrap___u38a3`,
	"height100": `FormSelect-module__height-100___u3zIB`,
	"width50": `FormSelect-module__width-50___y7DZd`,
	"width100": `FormSelect-module__width-100___Hc0S6`,
	"cursorPointer": `FormSelect-module__cursor-pointer___DAt3W`,
	"cursorNotAllowed": `FormSelect-module__cursor-not-allowed___f_t09`,
	"absoluteCentered": `FormSelect-module__absolute-centered___MNgy_`,
	"absolute": `FormSelect-module__absolute___saqUg`,
	"relative": `FormSelect-module__relative___yfKtc`,
	"fixed": `FormSelect-module__fixed___I6wyx`,
	"visible": `FormSelect-module__visible___GXdyP`,
	"invisible": `FormSelect-module__invisible___lFGyv`,
	"col90": `FormSelect-module__col-90___jDrOS`,
	"colAuto": `FormSelect-module__col-auto___acix2`,
	"medicalTabs": `FormSelect-module__medical-tabs___SMfJF`,
	"medicalTableNew": `FormSelect-module__medical-table-new___tCYbF`,
	"noPagination": `FormSelect-module__no-pagination___sV10m`,
	"medicalTableEmpty": `FormSelect-module__medical-table-empty___pnNrF`,
	"iconBtn": `FormSelect-module__icon-btn___bzX0Y`,
	"searchIcon": `FormSelect-module__search-icon___oKnBV`,
	"disableSelect": `FormSelect-module__disable-select___I26_d`,
	"breakWord": `FormSelect-module__break-word___qirLb`,
	"popupClearBtn": `FormSelect-module__popup-clear-btn___xiYdP`,
	"scrollMB20": `FormSelect-module__scroll-m-b-20___YWp2w`,
	"container": `FormSelect-module__container___Hwrvj`,
	"select": `FormSelect-module__select___vIyyK`,
	"disabled": `FormSelect-module__disabled___mN9V6`,
	"withError": `FormSelect-module__withError___XcTYY`,
	"icon": `FormSelect-module__icon___dKLwU`,
	"placeholder": `FormSelect-module__placeholder___Zwvee`,
	"multipleValue": `FormSelect-module__multipleValue___SvHwf`,
	"item": `FormSelect-module__item___Ptizs`,
	"closeIcon": `FormSelect-module__closeIcon___vX1Oc`,
	"value": `FormSelect-module__value___EUHkn`,
	"inputWrapper": `FormSelect-module__inputWrapper___csVBU`,
	"input": `FormSelect-module__input___dQped`,
	"iconsWrapper": `FormSelect-module__iconsWrapper___GXZXr`,
	"error": `FormSelect-module__error___FN68z`,
	"paper": `FormSelect-module__paper___L43bK`,
	"emptyPlaceholder": `FormSelect-module__emptyPlaceholder___FIsqr`
};
module.exports = ___CSS_LOADER_EXPORT___;
